import NavWrapper from "./NavWrapper";
import LogoLink from "./parts/LogoLink";
import LogoOrBackLink from "./parts/LogoOrBackLink";
import UserMenu from "./UserMenu/UserMenu";

export default function Nav() {
  return (
    <NavWrapper>
      <LogoOrBackLink>
        <LogoLink />
      </LogoOrBackLink>
      <UserMenu />
    </NavWrapper>
  );
}
